const ActionType = {
    IS_LOGIN: 'IS_LOGIN',
    IS_LOGOUT: 'IS_LOGOUT',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    UPDATE_TNC_ACCEPTANCE: 'UPDATE_TNC_ACCEPTANCE'
}

export default ActionType;
